/*#########################################################
    全画面共通設定
#########################################################*/
// 現在のページ名を取得
window.page_name = document.querySelector('meta[name="page"]').getAttribute('content');
// 読み込み中スピナー
window.spinner_border = '<div class="spinner text-center my-3"><span class="spinner-border text-primary"></span></div>';
// 都道府県リスト
window.pref = { 1: '北海道', 2: '青森県', 3: '岩手県', 4: '宮城県', 5: '秋田県', 6: '山形県', 7: '福島県', 8: '茨城県', 9: '栃木県', 10: '群馬県', 11: '埼玉県', 12: '千葉県', 13: '東京都', 14: '神奈川県', 15: '新潟県', 16: '富山県', 17: '石川県', 18: '福井県', 19: '山梨県', 20: '長野県', 21: '岐阜県', 22: '静岡県', 23: '愛知県', 24: '三重県', 25: '滋賀県', 26: '京都府', 27: '大阪府', 28: '兵庫県', 29: '奈良県', 30: '和歌山県', 31: '鳥取県', 32: '島根県', 33: '岡山県', 34: '広島県', 35: '山口県', 36: '徳島県', 37: '香川県', 38: '愛媛県', 39: '高知県', 40: '福岡県', 41: '佐賀県', 42: '長崎県', 43: '熊本県', 44: '大分県', 45: '宮崎県', 46: '鹿児島県', 47: '沖縄県' };
// Tokenの取得
window.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

/*#########################################################
    モーダル表記
#########################################################*/
window.make_modal = (options = []) => {
    reset_modal();
    let $modal = document.getElementById('modal');
    const mode = options.mode || '';
    let modal_options = {
        backdrop: true,
        keyboard: true,
    };
    // 固定モーダルの場合（ローディング時などに使用）
    if (mode == 'static') {
        modal_options = {
            backdrop: 'static',
            keyboard: false,
        }
        $modal.classList.remove('fade');
        $modal.querySelectorAll('[data-bs-dismiss="modal"]').forEach((el) => {
            el.style.display = 'none';
        });
    }
    $modal.querySelector('#modal_title').innerHTML = options.title || null;
    $modal.querySelector('#modal_body').innerHTML = options.body || null;
    $modal.querySelector('#modal_footer').innerHTML = options.footer || null;
    new bootstrap.Modal($modal, modal_options).show();
}
window.close_modal = () => {
    return new Promise((resolve) => {
        let $modal = document.getElementById('modal');
        bootstrap.Modal.getInstance($modal).hide();
        // 閉じた時にリセットする
        $modal.addEventListener('hidden.bs.modal', function (event) {
            reset_modal();
            resolve();
        });
    });
}
window.reset_modal = () => {
    let $modal = document.getElementById('modal');
    $modal.classList.add('fade');
    $modal.querySelector('#modal_title').innerHTML = null;
    $modal.querySelector('#modal_body').innerHTML = null;
    $modal.querySelector('#modal_footer').innerHTML = null;
    $modal.querySelectorAll('*').forEach((el) => {
        el.removeAttribute('style');
    });
}

/*#########################################################
    トースト表記
#########################################################*/
window.make_toast = (toasts) => {
    const toast_item = getCloneNode(document.getElementById('toast_item')).childNodes[1];
    const toast_box = document.getElementById('toast_box');
    for (let i in toasts) {
        toast_item.querySelector('[data-content="title"]').innerHTML = toasts[i].title || null;
        toast_item.querySelector('[data-content="time"]').innerHTML = toasts[i].time || null;
        toast_item.querySelector('[data-content="body"]').innerHTML = toasts[i].body || null;
        toast_item.classList.add('toast-' + (toasts[i].type || 'light'));
        toast_item.setAttribute('data-bs-autohide', toasts[i].autohide || "true");
        toast_box.appendChild(toast_item);
        // Toast が非表示されたら削除
        toast_item.addEventListener("hidden.bs.toast", function () {
            toast_item.remove();
        });
    }
    const toastElList = [].slice.call(toast_box.querySelectorAll(".toast"));
    const toastList = toastElList.map(function (toastEl) {
        const option = {};
        const toast = new bootstrap.Toast(toastEl, option);
        toast.show();
        return toast;
    });
}


/*#########################################################
    ツールチップの表示
#########################################################*/
window.addEventListener('load', function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    })
});


/*#########################################################
    パスワードの変更確認
#########################################################*/
if (page_name == "mypage.edit") {
    const $password = document.querySelector('input[type="password"]');
    window.acepted = false;
    $password.addEventListener('focus', (event) => {
        if ($password.classList.contains('acepted') == false) {
            const selector_text = "document.querySelector(\'input[type=\\\'password\\\']\')";
            const options = {
                title: '確認',
                body: 'パスワードは変更するときのみ入力してください。',
                footer: '<button type="button" class="btn btn-success" data-bs-dismiss="modal" onclick="' + selector_text + '.classList.add(\'acepted\');' + selector_text + '.focus();">パスワードの変更をする</button>'
            };
            make_modal(options);
        }
    });
    $password.addEventListener('blur', (event) => {
        $password.classList.remove('acepted');
    });
}

/*#########################################################
    APIの取得
    {
        api: null,
        _method: "GET",
        formdata: null,
        callback: null,
        e_callback: null,
        carry_data: null
    }
#########################################################*/
window.api = ({
    api = null,
    _method = "GET",
    formdata = null,
    callback = null,
    e_callback = null,
    carry_data = null
}) => {
    if (!api) {
        return [];
    }
    formdata = formdata || new FormData();
    formdata.set('_method', _method);
    return fetch(
        api,
        {
            method: "POST",
            headers: {
                'X-CSRF-TOKEN': token,
            },
            body: formdata,
        })
        .then(response => {
            if (response.status == 419) {
                // 419エラーの場合はリロード
                throw new Error(419);
            } else if (!response.ok && !e_callback) {
                // エラーがあってもe_callbackがある場合は通常処理へ分岐
                throw new Error(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            if (data.error) {
                if (e_callback) {
                    return e_callback(data, carry_data);
                } else {
                    if (data.messageText) {
                        throw new Error(data.messageText);
                    } else {
                        throw new Error('');
                    }
                }
            }
            if (callback) {
                return callback(data, carry_data);
            } else {
                // callbackがない場合は何もしない
            }
        })
        .catch(error => {
            // 419エラーの場合はリロード
            if (error.message == 419) {
                return window.location.reload();
            } else {
                (async (error) => {
                    // awaitを使うと、なぜかmodalが表示されないので、一旦コメントアウト
                    // await close_modal();
                    close_modal();
                    make_modal({
                        title: 'エラー',
                        body: 'エラーが発生しました。<br />' + error.message.replace(/\\n/g, '<br>'),
                    });
                })(error);
            }
        });
}
window.api_promise = async ({
    api = null,
    _method = "GET",
    formdata = null
}) => {
    return new Promise((resolve, reject) => {
        if (!api) {
            resolve([]);
        }
        formdata = formdata || new FormData();
        formdata.set('_method', _method);
        fetch(api, {
            method: "POST",
            headers: {
                'X-CSRF-TOKEN': token,
            },
            body: formdata,
        })
            .then(response => {
                if (response.status == 419) {
                    // 419エラーの場合はリロード
                    return window.location.reload();
                }
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    if (data.messageText) {
                        throw new Error(data.messageText);
                    } else {
                        throw new Error('');
                    }
                } else {
                    resolve(data);
                }
            })
            .catch(error => {
                reject(error);
            });
    });
}

/*#########################################################
    クリックで表示切り替え
    [data-target = "#target_id"]
#########################################################*/

window.section_toggle = (item) => {
    const target = document.querySelector(item.getAttribute('data-target'));
    const target_groups = target.parentNode.querySelectorAll('.toggle-section');
    if (target_groups && target) {
        let promise = new Promise((resolve, reject) => {
            target_groups.forEach(item => {
                item.classList.remove('show');
            });
            resolve({ target, target_groups, item });
        });
        promise.then(({ target, target_groups, item }) => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    target_groups.forEach(item => {
                        item.classList.remove('active');
                    });
                    resolve({ target, target_groups, item });
                }, 75)
            })
        }).then(({ target, target_group, item }) => {
            target.classList.add('active');
            return { target, target_groups, item };
        }).then(({ target, target_groups }) => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    target_groups.forEach(item => {
                        target.classList.add('show');
                    });
                    resolve({ target, target_groups, item });
                }, 75)
            })
        }).then(({ target, target_group, item }) => {
            if (item.getAttribute('data-scroll') == "true") {
                target.scrollIntoView();
            }
        });
    }
}
// トグルスイッチの取得
const toggle_switches = (document.querySelector('[data-target]')) ? document.querySelectorAll('[data-target]') : null;
if (toggle_switches) {
    toggle_switches.forEach(item => {
        item.addEventListener('change', (event) => {
            section_toggle(item);
        });
    });
}


/*#########################################################
    リンクでモーダルを表示
#########################################################*/
window.addEventListener('DOMContentLoaded', function () {
    const url_hash = location.hash;
    if (url_hash) { // アンカーリンクがある場合
        const $target = document.querySelector(url_hash);
        if ($target && $target.classList.contains("modal")) { // モーダルがある場合
            const modal = new bootstrap.Modal($target);
            modal.show();
        }
    }
});



/*#########################################################
    クリックで全文表示
#########################################################*/

document.querySelectorAll('.line-clamp').forEach(item => {
    item.addEventListener('click', (event) => {
        event.target.classList.remove('line-clamp');
    });
});

/*#########################################################
 * データをPOSTする
 * @param String アクション
 * @param Object POSTデータ連想配列
 * 記述元Webページ http://fujiiyuuki.blogspot.jp/2010/09/formjspost.html
 * サンプルコード
 * <a onclick="execPost('/hoge', {'fuga':'fuga_val', 'piyo':'piyo_val'});return false;" href="#">POST送信</a>
    https://gist.github.com/zuzu/c68e105d966c4d235334
#########################################################*/
window.execPost = ({
    action = "",
    data = [],
    target = ""
}) => {
    var form = document.createElement("form");
    form.setAttribute("action", action);
    form.setAttribute("target", target);
    form.setAttribute("method", "post");
    form.style.display = "none";
    document.body.appendChild(form);
    if (data !== undefined) {
        data._token = token;
        for (var paramName in data) {
            var input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', paramName);
            input.setAttribute('value', data[paramName]);
            form.appendChild(input);
        }
    }
    form.submit();
    // form.remove();
}